var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('z-notificacao',{ref:"notificacao"}),_c('z-alerta',{ref:"alerta",attrs:{"persistent":""}}),_c('z-dialogo-pergunta',{ref:"dialogo_pergunta"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }